import type { EasingType } from '@visactor/vrender-core';
import { AttributeUpdateType } from '@visactor/vrender-core/event/constant';
import { ACustomAnimate } from './custom-animate';
import { applyAnimationTransientAttributes } from './transient';

export class FromTo extends ACustomAnimate<Record<string, number>> {
  declare valid: boolean;

  keys: string[];

  constructor(from: null, to: null, duration: number, easing: EasingType, params?: any) {
    super(from, to, duration, easing, params);
    this.from = from ?? {};
  }

  protected applyTransientFromAttributes(): void {
    applyAnimationTransientAttributes(this.target, this.from, AttributeUpdateType.ANIMATE_START);
  }

  onBind(): void {
    super.onBind();

    // 如果存在from，不存在to，那么需要设置给props
    Object.keys(this.from).forEach(key => {
      if (this.props[key] == null) {
        this.props[key] = this.target.getGraphicAttribute(key);
      }
    });

    // 如果入场动画，那么需要设置属性
    if (this.target.context?.animationState === 'appear') {
      (this.target as any).applyFinalAttributeToAttribute();
    }
    if (this.params?.controlOptions?.immediatelyApply !== false) {
      this.applyTransientFromAttributes();
    }
  }

  onFirstRun(): void {
    // 获取上一步的属性值作为起始值
    this.from = { ...this.getLastProps(), ...this.from };
    const startProps = this.animate.getStartProps();
    this.propKeys &&
      this.propKeys.forEach(key => {
        this.from[key] = this.from[key] ?? startProps[key];
      });
    // TODO：比较hack
    // 如果是入场动画，那么还需要设置属性
    this.applyTransientFromAttributes();
  }

  deleteSelfAttr(key: string): void {
    this.deleteSelfAttrs([key]);
  }

  deleteSelfAttrs(keys: string[]): void {
    super.deleteSelfAttrs(keys);
    this.from = this.removeKeysFromRecord(this.from, keys);
  }

  /**
   * 更新执行的时候调用
   * 如果跳帧了就不一定会执行
   */
  update(end: boolean, ratio: number, out: Record<string, any>): void {
    // TODO 需要修复，只有在开始的时候才调用
    this.onStart();
    if (!this.props || !this.propKeys) {
      return;
    }
    // 应用缓动函数
    const easedRatio = this.easing(ratio);
    this.runInterpolateUpdate(this.from, this.props, easedRatio);
    this.onUpdate(end, easedRatio, out);
    this.syncAttributeUpdate();
  }
}
